// UUID generator supporting older browsers
function randomUUID() {
    return 'xxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export const giftcardsApi = {

    /**
     * Retrieves all giftcards
     * @param company_id
     */
    getAllGiftcards () {
        return axios.get(`/api/admin/giftcard-management`)
    },

    /**
     * Search for Giftcard by code
     * @param code
     */
    searchGiftcard (code) {
        return axios.get(`/api/giftcards/search/${code}`);
    },

    /**
     * Redeem Giftcard
     *
     * @param giftcard_code
     * @param amount
     * @param currency
     * @param capture
     * @param location_id
     * @param comment
     */
    redeemGiftcard (giftcard_code, amount, currency, capture, location_id, comment) {
        return axios.post(`/v1/giftcards/${giftcard_code}/redeem`, {
            amount,
            currency,
            capture,
            location_id,
            comment,
        }, {
            headers: {
                // We apply idempotency here to prevent the request from possibly being duplicated and re-processed
                'X-Gifty-Idempotency-Key': randomUUID()
            }
        });
    },

    /**
     * Issue Giftcard
     *
     * @param giftcard_code
     * @param amount
     * @param currency
     * @param promotional
     * @param location_id
     * @param package_id
     * @param comment
     */
    issueGiftcard (giftcard_code, amount, currency, promotional, location_id, package_id, comment) {
        return axios.post(`/v1/giftcards/${giftcard_code}/issue`, {
            amount,
            currency,
            promotional,
            location_id,
            package_id,
            comment,
        }, {
            headers: {
                // We apply idempotency here to prevent the request from possibly being duplicated and re-processed
                'X-Gifty-Idempotency-Key': randomUUID()
            }
        });
    },

    /**
     * Extend the validity of a Giftcard
     *
     * @param giftcard_code
     * @param expires_at
     */
    extendGiftcard (giftcard_code, expires_at) {
        return axios.post(`/v1/giftcards/${giftcard_code}/extend`, {
            expires_at
        }, {
            headers: {
                // We apply idempotency here to prevent the request from possibly being duplicated and re-processed
                'X-Gifty-Idempotency-Key': randomUUID()
            }
        });
    },

};
